export default "__VITE_ASSET__WV8Wsqy1__"